import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import { formatNullable } from "../../../../../../common/src/util/dataUtil";
import config from "../../../../../../server/src/config";

import * as AdminActions from "../../../../actions/admin";
import {hasCommonProps} from "../../../../utils/Util";

export const defaultState = {
    Bank: '',
    Regnr: '',
    Kontonr: '',
    Bank_Adr: '',
    Bank_Postnr: '',
    Kontingent_dette_sem: '',
    Kontingent_naeste_sem: '',
    Passiv_kontingent_dette_sem: '',
    Passiv_kontingent_naeste_sem: '',
    KmSats: '',
    UNIKON_kontingent: '',
    SMS_kontingent: '',
    Mobil_kontingent: ''
};

class SettingsGeneral extends React.Component {

    static propTypes = {
        editMode: PropTypes.bool,
        section: PropTypes.object.isRequired,
        sectionNo: PropTypes.string.isRequired,
        isDDB: PropTypes.bool.isRequired,
        isSection: PropTypes.bool.isRequired,
        isClub: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.getStateFromStore(props));
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.editMode || ((nextProps.section === null && this.props.section !== null) || (nextProps.section !== null && (this.props.section === null || this.props.sectionNo !== nextProps.sectionNo)))) this.setState(this.getStateFromStore(nextProps));
    }

    getStateFromStore(props) {
        if (props.section === null)
            return defaultState;
        else {
            const section = props.section;
            return {
                Bank: section.Bank === null ? '' : section.Bank,
                Regnr: section.Regnr === null ? '' : section.Regnr,
                Kontonr: section.Kontonr === null ? '' : section.Kontonr,
                Bank_Adr: section.Bank_Adr === null ? '' : section.Bank_Adr,
                Bank_Postnr: section.Bank_Postnr === null ? '' : section.Bank_Postnr,
                Kontingent_dette_sem: section.Kontingent_dette_sem === null ? '' : String(section.Kontingent_dette_sem).replace('.', ','),
                Kontingent_naeste_sem: section.Kontingent_naeste_sem === null ? '' : String(section.Kontingent_naeste_sem).replace('.', ','),
                Passiv_kontingent_dette_sem: section.Passiv_kontingent_dette_sem === null ? '' : String(section.Passiv_kontingent_dette_sem).replace('.', ','),
                Passiv_kontingent_naeste_sem: section.Passiv_kontingent_naeste_sem === null ? '' : String(section.Passiv_kontingent_naeste_sem).replace('.', ','),
                KmSats: section.KmSats === null ? '' : String(section.KmSats).replace('.', ','),
                UNIKON_kontingent: section.UNIKON_kontingent === null ? '' : String(section.UNIKON_kontingent).replace('.', ','),
                SMS_kontingent: section.SMS_kontingent === null ? '' : String(section.SMS_kontingent).replace('.', ','),
                Mobil_kontingent: section.Mobil_kontingent === null ? '' : String(section.Mobil_kontingent).replace('.', ','),
            }
        }
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    // TODO: Should it be possible to not have a zipCode?
    save = (onSuccess = null) => {
        if (this.allInputValid()) {
            const entity = {
                Bank: this.state.Bank === '' ? null : this.state.Bank,
                Regnr: this.state.Regnr === '' ? null : this.state.Regnr,
                Kontonr: this.state.Kontonr === '' ? null : this.state.Kontonr,
                Bank_Adr: this.state.Bank_Adr === '' ? null : this.state.Bank_Adr,
                Bank_Postnr: this.state.Bank_Postnr === '' ? null : this.state.Bank_Postnr,
            }

            if(this.props.isDDB){
                entity.Kontingent_dette_sem = this.state.Kontingent_dette_sem === '' ? null : Number(this.state.Kontingent_dette_sem.replace(',', '.'));
                entity.Kontingent_naeste_sem = this.state.Kontingent_naeste_sem === '' ? null : Number(this.state.Kontingent_naeste_sem.replace(',', '.'));
                entity.Passiv_kontingent_dette_sem = this.state.Passiv_kontingent_dette_sem === '' ? null : Number(this.state.Passiv_kontingent_dette_sem.replace(',', '.'));
                entity.Passiv_kontingent_naeste_sem = this.state.Passiv_kontingent_naeste_sem === '' ? null : Number(this.state.Passiv_kontingent_naeste_sem.replace(',', '.'));
                entity.KmSats = this.state.KmSats === '' ? null : Number(this.state.KmSats.replace(',', '.'));
                entity.UNIKON_kontingent = this.state.UNIKON_kontingent === '' ? null : Number(this.state.UNIKON_kontingent.replace(',', '.'));
                entity.SMS_kontingent = this.state.SMS_kontingent === '' ? null : Number(this.state.SMS_kontingent.replace(',', '.'));
                entity.Mobil_kontingent = this.state.Mobil_kontingent === '' ? null : Number(this.state.Mobil_kontingent.replace(',', '.'));

                this.props.dispatch(AdminActions.updateGeneral(entity, onSuccess))
            } else {
                this.props.dispatch(AdminActions.updateSection(this.props.section.Sektionsnr, entity, onSuccess));
            }
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }

    fields = [];
    render() {
        const {By} = this.state.Bank_Postnr === '' ? '' : this.props.admin.zipCodes.get(this.state.Bank_Postnr) || '';
        /*     const updateReq = this.props.club === null ? null : this.props.club.UpdateRequests.find(req => req.type === 'club') || null;
             const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);*/
        const editMode = this.props.editMode
        return <div className={"form-page settings-general " + (editMode ? "editable" : "read-only")}>
            <table className="main-form-table">
                <tbody>
                    <tr className="normal-row">
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="Bank">Bank</label></span></td>
                        <td colSpan={3} className={"data-cell"}>
                            {editMode ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.string}
                                    placeholder=""
                                    className="field-1 field400"
                                    containerClassName="display-inline-block"
                                    name="Bank"
                                    id="Bank"
                                    maxLength="35"
                                    value={this.state.Bank}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[1] = instance; }}
                                />
                                : <span className="value-text">{this.state.Bank}</span>}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="Adresse">Adresse</label></span></td>
                        <td colSpan={3} className={"data-cell"}>
                            {editMode ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.string}
                                    placeholder=""
                                    className="field-1 field400"
                                    containerClassName="display-inline-block"
                                    name="Bank_Adr"
                                    id="Bank_Adr"
                                    maxLength="35"
                                    value={this.state.Bank_Adr}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[2] = instance; }}
                                />
                                : <span className="value-text">{this.state.Bank_Adr}</span>}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="Postnr">Postnr</label></span></td>
                        <td colSpan={3} className={"data-cell"}>
                            {editMode ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 small-field"
                                    containerClassName="display-inline-block"
                                    name="Bank_Postnr"
                                    id="Bank_Postnr"
                                    maxLength="4"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]}
                                    value={this.state.Bank_Postnr}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[3] = instance; }}
                                />
                                : <span className="value-text">{this.state.Bank_Postnr}</span>}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="By">By</label></span></td>
                        <td colSpan={3} className={"data-cell"}>
                            <span className="value-text">{By}</span>
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="Regnr">Regnr.</label></span></td>
                        <td colSpan={3} className={"data-cell"}>
                            {editMode ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 small-field"
                                    containerClassName="display-inline-block"
                                    name="Regnr"
                                    id="Regnr"
                                    maxLength="4"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]}
                                    value={this.state.Regnr}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[4] = instance; }}
                                />
                                : <span className="value-text">{this.state.Regnr}</span>}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="Kontonr">Kontonr.</label></span></td>
                        <td colSpan={3} className={"data-cell"}>
                            {editMode ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1"
                                    containerClassName="display-inline-block"
                                    name="Kontonr"
                                    id="Kontonr"
                                    maxLength="14"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,14}"}]}
                                    value={this.state.Kontonr}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[5] = instance; }}
                                />
                                : <span className="value-text">{this.state.Kontonr}</span>}
                        </td>
                    </tr>
                    {this.props.isDDB ?
                        <React.Fragment>
                            <tr className="normal-row">
                                <td className={"label-cell"}><span className="label-text"><label htmlFor="Kontingent_dette_sem">Kontingent dette halvår</label></span></td>
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.float}
                                            placeholder=""
                                            className="field-1 medium-field"
                                            containerClassName="display-inline-block"
                                            name="Kontingent_dette_sem"
                                            id="Kontingent_dette_sem"
                                            value={this.state.Kontingent_dette_sem}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[6] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.Kontingent_dette_sem}</span>}
                                </td>

                                <td className={"label-cell"}><span className="label-text"><label htmlFor="Kontingent_naeste_sem">Kontingent næste halvår</label></span></td>
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.float}
                                            placeholder=""
                                            className="field-1 medium-field"
                                            containerClassName="display-inline-block"
                                            name="Kontingent_naeste_sem"
                                            id="Kontingent_naeste_sem"
                                            value={this.state.Kontingent_naeste_sem}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[7] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.Kontingent_naeste_sem}</span>}
                                </td>
                            </tr>
                            <tr className="normal-row">
                                <td className={"label-cell"}><span className="label-text"><label htmlFor="Passiv_kontingent_dette_sem">Passivt kontingent dette halvår</label></span></td>
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.float}
                                            placeholder=""
                                            className="field-1 medium-field"
                                            containerClassName="display-inline-block"
                                            name="Passiv_kontingent_dette_sem"
                                            id="Passiv_kontingent_dette_sem"
                                            value={this.state.Passiv_kontingent_dette_sem}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[8] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.Passiv_kontingent_dette_sem}</span>}
                                </td>

                                <td className={"label-cell"}><span className="label-text"><label htmlFor="Passiv_kontingent_naeste_sem">Passivt kontingent næste halvår</label></span></td>
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.float}
                                            placeholder=""
                                            className="field-1 medium-field"
                                            containerClassName="display-inline-block"
                                            name="Passiv_kontingent_naeste_sem"
                                            id="Passiv_kontingent_naeste_sem"
                                            value={this.state.Passiv_kontingent_naeste_sem}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[9] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.Passiv_kontingent_naeste_sem}</span>}
                                </td>
                            </tr>
                            <tr className="normal-row">
                                <td className={"label-cell"}><span className="label-text"><label htmlFor="KmSats">Kilometersats</label></span></td>
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.float}
                                            placeholder=""
                                            className="field-1 medium-field"
                                            containerClassName="display-inline-block"
                                            name="KmSats"
                                            id="KmSats"
                                            value={this.state.KmSats}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[10] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.KmSats}</span>}
                                </td>

                                <td className={"label-cell"}><span className="label-text"><label htmlFor="UNIKON_kontingent">Kontingent UNIKON/TAURIS-SMS</label></span></td>
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.float}
                                            placeholder=""
                                            className="field-1 medium-field"
                                            containerClassName="display-inline-block"
                                            name="UNIKON_kontingent"
                                            id="UNIKON_kontingent"
                                            value={this.state.UNIKON_kontingent}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[11] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.UNIKON_kontingent}</span>}
                                </td>
                            </tr>
                            <tr className="normal-row">
                                <td className={"label-cell"}><span className="label-text"><label htmlFor="SMS_kontingent">Kontingent SMS-abonnement</label></span></td>
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.float}
                                            placeholder=""
                                            className="field-1 medium-field"
                                            containerClassName="display-inline-block"
                                            name="SMS_kontingent"
                                            id="SMS_kontingent"
                                            value={this.state.SMS_kontingent}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[12] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.SMS_kontingent}</span>}
                                </td>

                                <td className={"label-cell"}><span className="label-text"><label htmlFor="Mobil_kontingent">Kontingent SIM-kort-abonnement</label></span></td>
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.float}
                                            placeholder=""
                                            className="field-1 medium-field"
                                            containerClassName="display-inline-block"
                                            name="Mobil_kontingent"
                                            id="Mobil_kontingent"
                                            value={this.state.Mobil_kontingent}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[13] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.Mobil_kontingent}</span>}
                                </td>
                            </tr>
                        </React.Fragment>
                        :null
                    }
                </tbody>
            </table>
        </div>
    }
}

const mapStateToProps = (state) => ({
    admin: {
        zipCodes: state.admin.zipCodes,
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(SettingsGeneral);




// WEBPACK FOOTER //
// ./src/client/src/components/pages/settings/subPages/SettingsGeneral.js